import React, { useEffect, useState } from 'react'
import { useCalc } from '../../context/CalcContext'

const GrowthProcentage = ({ type = 'growth' }) => {
  const { dataSet, dataSetBase, dataSetUpper, dataSetLower, dataSetCapital } =
    useCalc()
  const [growth, setGrowth] = useState('-')
  const [capital, setCapital] = useState('-')

  useEffect(() => {
    if (dataSetUpper[24] && dataSetBase[24]) {
      setGrowth(Math.round((dataSetUpper[24].y / dataSetBase[24].y - 1) * 100))
    }
  }, [dataSetBase, dataSetUpper])

  useEffect(() => {
    if (dataSetCapital[24]) {
      setCapital(Math.round(dataSetCapital[24].y / 10000) / 100)
    }
  }, [dataSetCapital])

  if (type === 'growth') {
    return <span>{growth}</span>
  }
  if (type === 'capital') {
    return <span>{capital}</span>
  }
  return '-'
}

export default GrowthProcentage
